import { showToast, UPDATE_FEE_REDUCER_DATA } from ".";
import Api from "../helpers/Api";
import { UPDATE_HOME_REDUCER } from "./home";

export const UPDATE_REPORT_DATA = "Report/UPDATE_REPORT_DATA";
export const RESET_REPORT_DATA = "Report/RESET_REPORT_DATA";

export const showLoader = (show) => async (dispatch) => {
  await dispatch({
    type: UPDATE_REPORT_DATA,
    payload: { isLoading: show },
  });
};

export const resetReport = () => async (dispatch) => {
  await dispatch({ type: RESET_REPORT_DATA });
};

export const getFeeAccounts = () => async (dispatch, getState) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: "/fees/get_fee_accounts",
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_REPORT_DATA,
      payload: { feeAccounts: response.fee_accounts },
    });
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { isFinance: response.is_finance },
    });
  }
  await dispatch(showLoader(false));
  if (response.message) {
    await dispatch(showToast(response.message));
  }
  return response;
};

export const fetchReports =
  (feeAccountIDs, startDate, endDate, daywiseReport = false) =>
  async (dispatch) => {
    await dispatch(showLoader(true));
    const response = await Api({
      method: "get",
      url: `/fees/fetch_reports?fee_account_ids=${feeAccountIDs}&start_date=${startDate}&end_date=${endDate}&daywise_report=${daywiseReport}`,
    });
    if (response.success) {
      await dispatch({
        type: UPDATE_REPORT_DATA,
        payload: {
          payments: response.payments,
          accountants: response.accountants,
          campuses: response.campuses,
          selectedCampus: response.selected_campus,
          daywiseReportData: response.daywise_payment_report,
        },
      });
      await dispatch({
        type: UPDATE_FEE_REDUCER_DATA,
        payload: {
          institutesTags: response.tags,
          institutesTagGroups: response.tag_groups,
        },
      });
    }
    await dispatch(showLoader(false));
    if (!!response.message) {
      await dispatch(showToast(response.message));
    }
  };

export const fetchStudentsData = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: `/fees/fetch_students_data`,
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_REPORT_DATA,
      payload: {
        students: response.students,
        campuses: response.campuses,
        classrooms: response.classrooms,
      },
    });
  }
  await dispatch(showLoader(false));
  return response;
};

export const getSalesReport = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: `/fees/get_sales_report`,
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_REPORT_DATA,
      payload: {
        salesReport: response.sales_report,
        feeAccounts: response.fee_accounts,
      },
    });
  }
  await dispatch(showLoader(false));
};

export const getReceiptsReport = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: "/fees/get_receipts_report",
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_REPORT_DATA,
      payload: {
        receiptsReport: response.receipts_report,
        feeAccounts: response.fee_accounts
      },
    });
  }
  await dispatch(showLoader(false));
};
